export enum TemplateCategory {
    Marketplace = 0,
}
